import React from "react";
import { FluidSectionViewer } from "./FluidPreview/FluidSectionViewer";
import { SectionSkeleton } from "./shared/Components/SectionSkeleton";
export const FluidViewer = ({
  data,
  pageContext,
  wuiltContext
}) => {
  // Add state to track if component is mounted on client
  // this is because fluid elements depends on the grid container width
  // and we need to wait for the component to be mounted on client
  const [isMounted, setIsMounted] = React.useState(false);

  // Separate useEffect for client-side mounting detection
  React.useEffect(() => {
    setIsMounted(true);
  }, []);
  if (!isMounted) {
    return /*#__PURE__*/React.createElement(SectionSkeleton, null);
  }
  return /*#__PURE__*/React.createElement(FluidSectionViewer, {
    sectionData: data,
    pageContext: pageContext,
    wuiltContext: wuiltContext
  });
};
//# sourceMappingURL=FluidViewer.js.map